import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { MeioPag ,initialValueState, MeioPagState, MeioPagActions } from "./meiopg.model"

export interface MeioPagViewProps{
    meioPagState:MeioPagState
    meioPagActions:MeioPagActions
}


class MeioPagController extends Controller<MeioPag, MeioPagState, MeioPagActions> {
    constructor() {
        super(initialValueState.row.type,initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
        ]
    }

    private* novoActionEffects(actions:Payload){

    }
}

export const meioPagController = new MeioPagController()

export const mapStateToMeioPagProps = (state: ApplicationState) => ({
    meioPagState: state.meioPagState,
})

export const mapDispatchToMeioPagProps = (dispatch: Dispatch) => ({
    meioPagActions: bindActionCreators({...meioPagController.reducer.actions}, dispatch),
})